<!-- Footer -->
<footer class="fullscreen main-footer">

	<div class="content">

		<div class="column-auto">
			<small>© 2020 Boost</small>
		</div>

		<div class="column-auto footer-block">

			<div class="footer-block__list">
				<small>Todos los derechos reservados </small>
			</div>

			<span class="footer-block__list footer-block__list--point">|</span>

			<div class="footer-block__list">
				<a class="link" [routerLink]="['/aviso-legal']">Aviso legal</a>
			</div>

			<span class="footer-block__list footer-block__list--point">|</span>

			<div class="footer-block__list">
				<a class="link" [routerLink]="['/politica-proteccion-datos']">GDPR</a>
			</div>

			<div class="footer-icons">
				<a class="footer-icons__follow-icon" href="https://www.instagram.com/digital_boost/" target="_blank">
					<svg class="rrssSVG" viewBox="0 0 26 26">
						<g>
							<path d="M25.934 7.644c-.061-1.381-.284-2.331-.605-3.154-.33-.874-.838-1.656-1.503-2.306-.65-.66-1.438-1.173-2.302-1.498-.828-.32-1.773-.544-3.154-.605C16.978.015 16.536 0 13.005 0c-3.53 0-3.973.015-5.36.076-1.381.061-2.331.285-3.154.605-.874.33-1.656.838-2.307 1.503-.66.65-1.173 1.437-1.498 2.3C.366 5.314.142 6.258.08 7.64.015 9.03 0 9.473 0 13.003s.015 3.971.076 5.358c.061 1.382.285 2.331.605 3.154.33.874.843 1.656 1.503 2.306.65.66 1.438 1.173 2.302 1.498.828.32 1.773.544 3.155.605 1.386.06 1.828.076 5.36.076 3.53 0 3.972-.015 5.359-.076 1.381-.061 2.331-.284 3.154-.605 1.748-.675 3.13-2.057 3.805-3.804.32-.828.544-1.772.605-3.154.06-1.387.076-1.828.076-5.358 0-3.53-.005-3.972-.066-5.359zM23.592 18.26c-.056 1.27-.27 1.956-.447 2.413-.437 1.133-1.336 2.032-2.469 2.469-.457.177-1.148.39-2.413.446-1.372.062-1.783.077-5.253.077s-3.886-.015-5.253-.077c-1.27-.055-1.956-.269-2.413-.446-.564-.209-1.077-.539-1.493-.97-.432-.422-.762-.93-.97-1.494-.178-.457-.392-1.148-.448-2.412-.06-1.372-.076-1.783-.076-5.252 0-3.47.015-3.886.076-5.252.056-1.27.27-1.956.447-2.413.209-.563.539-1.076.976-1.493.421-.432.93-.762 1.493-.97.458-.178 1.149-.391 2.413-.447 1.372-.06 1.784-.076 5.253-.076 3.475 0 3.886.015 5.253.076 1.27.056 1.956.27 2.413.447.564.208 1.077.538 1.494.97.431.422.762.93.97 1.493.178.457.391 1.148.447 2.413.061 1.371.076 1.783.076 5.252s-.015 3.875-.076 5.246z"/>
							<path d="M12.675 6.5c-3.768 0-6.825 3.057-6.825 6.825 0 3.768 3.057 6.825 6.825 6.825 3.768 0 6.825-3.057 6.825-6.825 0-3.768-3.057-6.825-6.825-6.825zm0 11.252c-2.444 0-4.427-1.982-4.427-4.427 0-2.445 1.983-4.427 4.427-4.427 2.445 0 4.427 1.982 4.427 4.427 0 2.445-1.982 4.427-4.427 4.427zM21.45 6.175c0 .897-.728 1.625-1.625 1.625S18.2 7.072 18.2 6.175c0-.898.728-1.625 1.625-1.625s1.625.727 1.625 1.625z"/>
						</g>
					</svg>
				</a>
				<a class="footer-icons__follow-icon" href="https://www.linkedin.com/company/digital-boost/" target="_blank">
					<svg class="rrssSVG"  viewBox="0 0 26 27">
						<g>
							<path d="M25.993 26v-.001H26V16.42c0-4.685-1.02-8.295-6.557-8.295-2.662 0-4.449 1.445-5.178 2.815h-.077V8.562h-5.25V26h5.467v-8.634c0-2.273.435-4.471 3.281-4.471 2.804 0 2.846 2.594 2.846 4.617V26h5.461zM0 8.938L5.688 8.938 5.688 26 0 26zM3.25 0C1.456 0 0 1.45 0 3.235 0 5.02 1.456 6.5 3.25 6.5S6.5 5.02 6.5 3.235C6.499 1.449 5.043 0 3.25 0z"/>
						</g>
					</svg>
				</a>
			</div>

		</div>
	</div>

</footer>
